import React, { Component } from 'react';
import { Tabs, Tab, Grid, Cell, Card, CardTitle, CardText, CardActions, Button, CardMenu, IconButton } from 'react-mdl';


class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: 0 };
  }

  toggleCategories() {

      if (this.state.activeTab === 0) {
          return (
              <div className="projects-grid">
                  {/* Python 1 */}
                  <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
                      <CardTitle style={{
                          color: '#fff',
                          height: '176px',
                          background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/neuralNet.png?raw=true) center / cover'
                      }}/>
                      <CardText>
                          Classification of pneumonia in x-rays by training and using a CNN-model (Residual Neural
                          Network with 50 layers).
                      </CardText>
                      <CardActions border style={{textAlign: 'center'}}>
                          <a href="https://github.com/thewildling/ML-">
                              <Button colored style={{color: '#fda07d', fontWeight: 'bold'}}>Go to GitHub</Button>
                          </a>
                          <a href="https://www.ml.andersf.no/">
                              <Button colored style={{color: '#fda07d', fontWeight: 'bold'}}>Open Website</Button>
                          </a>
                      </CardActions>
                      <CardMenu style={{color: '#fff'}}>
                          <IconButton name="share"/>
                      </CardMenu>
                  </Card>

                  {/* Python 2 */}
                  <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
                      <CardTitle style={{
                          color: '#fff',
                          height: '176px',
                          background: 'url(https://github.com/thewildling/Knowledge_Based_Engineering/blob/main/Pictures/Robotarm-Iterations.png?raw=true) center / cover'
                      }}/>
                      <CardText>
                          Generating optimal lengths for links in a robot-arm (3-link open chain manipulator) by using
                          Genetic Algorithm (search heuristic algorithm) and displaying it in Siemens NX.
                      </CardText>
                      <CardActions border style={{textAlign: 'center'}}>
                          <a href="https://github.com/thewildling/Knowledge_Based_Engineering">
                              <Button colored style={{color: '#fda07d', fontWeight: 'bold'}}>Go to GitHub</Button>
                          </a>
                      </CardActions>
                      <CardMenu style={{color: '#fff'}}>
                          <IconButton name="share"/>
                      </CardMenu>
                  </Card>
              </div>

          )
      } else if (this.state.activeTab === 1) {
          return (
              <div className="projects-grid">
                  {/* C# 1 */}
                  <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
                      <CardTitle style={{
                          color: '#fff',
                          height: '176px',
                          background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/GUI-game.png?raw=true) center / cover'
                      }}/>
                      <CardText>
                          Operating game developed and deployed during summer 2020 while learning C# and JavaScript.
                      </CardText>
                      <CardActions border style={{textAlign: 'center'}}>
                          <a href="https://github.com/thewildling/SummerProject2020">
                              <Button colored style={{color: '#fda07d', fontWeight: 'bold'}}>Go to GitHub</Button>
                          </a>
                      </CardActions>
                      <CardMenu style={{color: '#fff'}}>
                          <IconButton name="share"/>
                      </CardMenu>
                  </Card>
              </div>

          )
      } else if (this.state.activeTab === 2) {
          return (
              <div className="projects-grid">
                  {/* NX 1 */}
                  <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
                      <CardTitle style={{
                          color: '#fff',
                          height: '176px',
                          background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/GUI-NodeResults.png?raw=true) center / cover'
                      }}/>
                      <CardText>
                          Creating a KBE-system for automatically analyzing a node in Siemes NX by use of Nastran (FEM)
                          based on user input.
                      </CardText>
                      <CardActions border style={{textAlign: 'center'}}>
                          <a href="https://github.com/thewildling/Knowledge_Based_Engineering">
                              <Button colored style={{color: '#fda07d', fontWeight: 'bold'}}>Go to GitHub</Button>
                          </a>
                      </CardActions>
                      <CardMenu style={{color: '#fff'}}>
                          <IconButton name="share"/>
                      </CardMenu>
                  </Card>

                  {/* NX 2 */}
                  <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
                      <CardTitle style={{
                          color: '#fff',
                          height: '176px',
                          background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/GUI-RailResult.png?raw=true) center / cover'
                      }}/>
                      <CardText>
                          Creating a KBE-system for automatically generating a rail path for a animal-feeder based on
                          user input.
                      </CardText>
                      <CardActions border style={{textAlign: 'center'}}>
                          <a href="https://github.com/thewildling/Knowledge_Based_Engineering">
                              <Button colored style={{color: '#fda07d', fontWeight: 'bold'}}>Go to GitHub</Button>
                          </a>
                      </CardActions>
                      <CardMenu style={{color: '#fff'}}>
                          <IconButton name="share"/>
                      </CardMenu>
                  </Card>

                  {/* NX 3 */}
                  <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
                      <CardTitle style={{
                          color: '#fff',
                          height: '176px',
                          background: 'url(https://github.com/anderf2706/Knowledge-based_engineering_project/blob/master/model1.png?raw=true) center / cover'
                      }}/>
                      <CardText>
                          Creating a KBE-system for automatically generating a chair in Siemens NX based on user input.
                      </CardText>
                      <CardActions border style={{textAlign: 'center'}}>
                          <a href="https://github.com/thewildling/Knowledge_Based_Engineering">
                              <Button colored style={{color: '#fda07d', fontWeight: 'bold'}}>Go to GitHub</Button>
                          </a>
                      </CardActions>
                      <CardMenu style={{color: '#fff'}}>
                          <IconButton name="share"/>
                      </CardMenu>
                  </Card>
              </div>

          )
      } else if (this.state.activeTab === 3) {
          return (
              <div className="projects-grid">
                  {/* Thesis 1 */}
                  <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
                      <CardTitle style={{
                          color: '#fff',
                          height: '176px',
                          background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/specialization_report_photo.png?raw=true) center / cover'
                      }}/>
                      <CardText>
                          Specialization project report on the topic of detecting gas leakages through acoustic signal processing.
                      </CardText>
                      <CardActions border style={{textAlign: 'center'}}>
                          <a href="https://drive.google.com/file/d/1nLu3Cy0HLdlRoADIrC7QAi1fX7yrxcjQ/view?usp=sharing">
                              <Button colored style={{color: '#fda07d', fontWeight: 'bold'}}>Open Paper</Button>
                          </a>
                      </CardActions>
                      <CardMenu style={{color: '#fff'}}>
                          <IconButton name="share"/>
                      </CardMenu>
                  </Card>

                  {/* Thesis 2 */}
                  <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
                      <CardTitle style={{
                          color: '#fff',
                          height: '176px',
                          background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/Master_thesis_cover.png?raw=true) center / cover'
                      }}/>
                      <CardText>
                          Master thesis concerning detection of gas leakages with machine learning techniques.
                      </CardText>
                      <CardActions border style={{textAlign: 'center'}}>
                          <a href="https://drive.google.com/file/d/16FMmCEnTDKU7z8awoVzcLRqzd8kRw8Rq/view?usp=sharing">
                              <Button colored style={{color: '#fda07d', fontWeight: 'bold'}}>Open Paper</Button>
                          </a>
                          <a href="https://github.com/thewildling/MasterThesis">
                              <Button colored style={{color: '#fda07d', fontWeight: 'bold'}}>Go to GitHub</Button>
                          </a>
                      </CardActions>
                      <CardMenu style={{color: '#fff'}}>
                          <IconButton name="share"/>
                      </CardMenu>
                  </Card>
              </div>
          )
      } else if (this.state.activeTab === 4) {
          return (
              <div className="projects-grid">
                  {/* Paper 1 */}
                  <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
                      <CardTitle style={{
                          color: '#fff',
                          height: '176px',
                          background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/MLpaper.png?raw=true) center / cover'
                      }}/>
                      <CardText>
                          Machine Learning: academic paper about pneumonia image classification with comparison between
                          CNN and KNN.
                      </CardText>
                      <CardActions border style={{textAlign: 'center'}}>
                          <a href="https://drive.google.com/file/d/1bUAQXlOdkQ3a5kcaH_fcBfg1Dv8w7VVm/view?usp=sharing">
                              <Button colored style={{color: '#fda07d', fontWeight: 'bold'}}>Open Paper</Button>
                          </a>
                      </CardActions>
                      <CardMenu style={{color: '#fff'}}>
                          <IconButton name="share"/>
                      </CardMenu>
                  </Card>

                  {/* Paper 2 */}
                  <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
                      <CardTitle style={{
                          color: '#fff',
                          height: '176px',
                          background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/EIT_rapport.png?raw=true) center / cover'
                      }}/>
                      <CardText>
                          Project paper about Smart Neighbourhoods and use of Digital Twins.
                      </CardText>
                      <CardActions border style={{textAlign: 'center'}}>
                          <a href="https://drive.google.com/file/d/1gqbI8V-xV0au0gpsKZpdgicN0PzIwDC6/view?usp=sharing">
                              <Button colored style={{color: '#fda07d', fontWeight: 'bold'}}>Open Paper</Button>
                          </a>
                      </CardActions>
                      <CardMenu style={{color: '#fff'}}>
                          <IconButton name="share"/>
                      </CardMenu>
                  </Card>

                  {/* Paper 3 */}
                  <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
                      <CardTitle style={{
                          color: '#fff',
                          height: '176px',
                          background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/Marin_rapport.png?raw=true) center / cover'
                      }}/>
                      <CardText>
                          Subject report on a Dynamic Boat Regulating project.
                      </CardText>
                      <CardActions border style={{textAlign: 'center'}}>
                          <a href="https://drive.google.com/file/d/1oDfjSL7Lho2xWCL_cpYNrvKRobq_J89e/view?usp=sharing">
                              <Button colored style={{color: '#fda07d', fontWeight: 'bold'}}>Open Paper</Button>
                          </a>
                      </CardActions>
                      <CardMenu style={{color: '#fff'}}>
                          <IconButton name="share"/>
                      </CardMenu>
                  </Card>
              </div>
          )
      } else if (this.state.activeTab === 5) {
          return (
              <div className="projects-grid">

                  {/* App 1 */}
                  <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
                      <CardTitle style={{
                          color: '#fff',
                          height: '176px',
                          background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/MMI.png?raw=true) center / cover'
                      }}/>
                      <CardText>
                          App design project in the course "Human-Computer Interaction".
                      </CardText>
                      <CardActions border style={{textAlign: 'center'}}>
                          <a href="https://www.figma.com/proto/qZuu5oCjgZ3OlH0wiOFGGz/PickApp!?node-id=1%3A2&scaling=scale-down">
                              <Button colored style={{color: '#fda07d', fontWeight: 'bold'}}>Open Figma</Button>
                          </a>
                      </CardActions>
                      <CardMenu style={{color: '#fff'}}>
                          <IconButton name="share"/>
                      </CardMenu>
                  </Card>

                  {/* App 2 */}
                  <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
                      <CardTitle style={{
                          color: '#fff',
                          height: '176px',
                          background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/EIT.png?raw=true) center / cover'
                      }}/>
                      <CardText>
                          App design project in the course "Experts in Team, Digital Twins".
                      </CardText>
                      <CardActions border style={{textAlign: 'center'}}>
                          <a href="https://www.figma.com/proto/wbcXm2i3f8SSE0acp8m0iq/SmartHood?node-id=151%3A3&scaling=scale-down&page-id=151%3A2">
                              <Button colored style={{color: '#fda07d', fontWeight: 'bold'}}>Open Figma</Button>
                          </a>
                      </CardActions>
                      <CardMenu style={{color: '#fff'}}>
                          <IconButton name="share"/>
                      </CardMenu>
                  </Card>
              </div>
          )
      }
  }

  render() {
    return(
      <div>
        <Tabs activeTab={this.state.activeTab} onChange={(tabId) => this.setState({ activeTab: tabId })} ripple>
             <Tab>Python</Tab>
             <Tab>JavaScript/C#</Tab>
             <Tab>KF/NX</Tab>
             <Tab>Master Thesis</Tab>
             <Tab>Academic Papers</Tab>
             <Tab>App Designs</Tab>
        </Tabs>
          <Grid>
            <Cell col={12}>
              <div className="content">{this.toggleCategories()}</div>
            </Cell>
          </Grid>
      </div>
    )
  }
}

export default Projects;



// WEBPACK FOOTER //
// ./src/components/projects.js